import { connect } from 'react-redux';
import {
  updateAuditLogsSearchQuery,
  resetAuditLogsSearchQuery
} from '../../../redux/Inventory/actions/components/audit-log-search';
import { fetchInventoryAuditLogsForItem } from '../../../redux/Inventory/sagas/components/view-item/routines';
import {
  getIsFetchingItemAuditLogs,
  getIsFetchedItemAuditLogs
} from '../../../redux/Inventory/selectors/components/view-item';
import { fetchInventoryAuditLogsSearchOptions } from '../../../redux/Inventory/sagas/audit-log/routines';
import {
  getUserSearchOptions,
  getLocationSearchOptions,
  getZoneSearchOptions,
  getIsFetching as getIsFetchingSearchOptions
} from '../../../redux/Inventory/selectors/audit-log/search-option';
import {
  getPaginationLoadedPages as getItemAuditLogsPaginationLoadedPages,
  getPaginationWithoutPages as getItemAuditLogsPaginationWithoutPages,
  getPaginationQueryOptions as getItemAuditLogsPaginationQueryOptions,
  getCurrentPageItems as getItemAuditLogsCurrentPageItems
} from '../../../redux/Inventory/selectors/components/view-item/audit-log-pagination';
import { clearInventoryItemAuditLogs } from '../../../redux/Inventory/actions/components/view-item';
import { getAuditLogSearchQuery } from '../../../redux/Inventory/selectors/components/audit-log-search';
import InventoryAuditLogSearch from '../../../components/inventory/AuditLogSearch';

function mapStateToProps(state, { item }) {
  const paginationQuery = getItemAuditLogsPaginationQueryOptions(state);
  const searchQuery = getAuditLogSearchQuery(state);
  return {
    showItemColumn: false,
    isItemSpecific: true,
    query: { ...paginationQuery, ...searchQuery },
    userOptions: getUserSearchOptions(state),
    itemOptions: [],
    tagOptions: [],
    locationOptions: getLocationSearchOptions(state),
    zoneOptions: getZoneSearchOptions(state),

    auditLogs: getItemAuditLogsCurrentPageItems(state),
    loadedPages: getItemAuditLogsPaginationLoadedPages(state),
    pagination: getItemAuditLogsPaginationWithoutPages(state),
    isFetching:
      getIsFetchingSearchOptions(state) || getIsFetchingItemAuditLogs(state),
    isFetched: getIsFetchedItemAuditLogs(state, item.id)
  };
}

function mapDispatchToProps(dispatch, { item }) {
  const { id: itemId } = item;
  return {
    onInit: () => {
      dispatch(fetchInventoryAuditLogsSearchOptions());
      dispatch(updateAuditLogsSearchQuery({ itemId }));
    },
    onChange: query => {
      dispatch(updateAuditLogsSearchQuery(query));
    },
    onSubmit: query => {
      dispatch(clearInventoryItemAuditLogs());
      dispatch(fetchInventoryAuditLogsForItem({ ...query, itemId }));
    },
    onReset: () => {
      dispatch(resetAuditLogsSearchQuery());
    },
    onUnmount: () => {
      dispatch(resetAuditLogsSearchQuery());
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryAuditLogSearch);
